export { default } from '@shikijs/langs/php'
